import { render } from "./Edit.vue?vue&type=template&id=225fe599&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=225fe599&lang=less&scoped=true"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225fe599"]])

export default __exports__